import { render, staticRenderFns } from "./FooterSpecial.vue?vue&type=template&id=306ad4fa&scoped=true"
import script from "./FooterSpecial.vue?vue&type=script&lang=js"
export * from "./FooterSpecial.vue?vue&type=script&lang=js"
import style0 from "./FooterSpecial.vue?vue&type=style&index=0&id=306ad4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ad4fa",
  null
  
)

export default component.exports